module.exports = __webpack_public_path__ + "static/img/rcontent2.af948e0f.png";